export default {"src":"/_next/static/media/divar.42e9fc7d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};